exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-c2d0f936] {\n  list-style-type: none;\n  display: table;\n  margin: 0 auto;\n  text-align: left;\n}\n", ""]);

// exports
